export default __webpack_public_path__ + "static/media/border-bottom3x.ef11c868.png";